import { render, staticRenderFns } from "./dv-table.vue?vue&type=template&id=4e61cb24"
import script from "./dv-table.vue?vue&type=script&lang=js"
export * from "./dv-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports